/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../lib/apiClient';

export const createOwnerEntity = createAsyncThunk(
  'ownerEntities/createOwnerEntity',
  async (createOwnerEntityObj, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post(`/api/ownerEntities`, createOwnerEntityObj);

      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

const initialState = {
  ownerEntityId: null,
  error: null,
};

export const createCommunitySlice = createSlice({
  name: 'createOwnerEntity',
  initialState,
  reducers: {},
  extraReducers: {
    [createOwnerEntity.fulfilled]: (state, action) => {
      state.ownerEntityId = action.payload.result;
    },
    [createOwnerEntity.rejected]: (state, action) => {
      state.error = action.payload;
    },
  },
});

export default createCommunitySlice.reducer;
